export function getHeaderStyle(
	backgroundColour?: string | null,
): { backgroundColor: string } | Record<string, never> {
	return backgroundColour ? { backgroundColor: `#${backgroundColour}` } : {};
}
